import * as TYPES from '../types';
import { PlayerAction, PlayerActions } from '../types';
import {defaultPlayers} from './init';

export const players = (state = {...defaultPlayers}, action: PlayerActions) => { // to review
  const newState = JSON.parse(JSON.stringify(state));
  switch (action.type) {

    case PlayerAction.REPLACE_CUSTOMERS_PLAYERS:
      if (!newState.customerPlayers) {
        newState.customerPlayers = {};
      }
      newState.customerPlayers[action.teamId] = action.customerPlayers;
      return newState;
    case PlayerAction.EXCLUDE_PLAYERS:
      if(!newState.playersExcluded){
        newState.playersExcluded = {};
      }
      newState.playersExcluded[action.gameId] = action.playersExcluded;
      return newState;
    case PlayerAction.SET_EXCLUDE_PLAYERS_BY_PERIOD:
      newState.playersExcludedByPeriod = action.playersExcludedByPeriod;
      return newState;
    default:
      return state;
  }
};

